import * as Styles from "./styles";

export function InfoText() {
  return (
    <Styles.Container>
      <p>
         O lançamento do aplicativo{' '}
        <a
          target="_blank"
          rel="noreferrer noopener"
          href="https://play.google.com/store/apps/details?id=com.ufpb.trabs_app"
        >
         Trabs
        </a> para coleta de sentimentos e satisfação ocorreu no dia 08 de novembro de 2022. Tão logo seu 
        uso seja incentivado pelos órgãos de saúde, os dados serão refletidos aqui.
        
        
      </p>
      <p>
        Acesse o manual do aplicativo{" "}
        <a target={'_blank'} rel="noreferrer" href={"https://drive.google.com/file/d/1XUwcny_dWgIGBMGgGrcORKfNzFyQIS9F/view?usp=share_link"}>
          <strong>
            aqui
          </strong>
        </a>.
      </p>
    </Styles.Container>
  );
}
